import { motion } from "framer-motion";
import { TrendingDown, Clock, Workflow, ShieldAlert } from "lucide-react";
import { useLang } from "@/context/LangContext";

const icons = [TrendingDown, Clock, Workflow, ShieldAlert];

const Problem = () => {
  const { t } = useLang();
  return (
    <section id="problem" className="relative py-32 md:py-40 overflow-hidden">
      <div
        className="glow-orb"
        style={{ width: 600, height: 600, background: "rgba(16,185,129,0.12)", top: 100, right: -200 }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          <div className="text-[11px] tracking-[0.3em] uppercase text-po-accent mb-6">
            {t.problem.eyebrow}
          </div>
          <h2 className="font-display font-semibold text-white text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-[-0.03em]">
            {t.problem.title}
            <br />
            <span className="font-serif-it text-po-text2">{t.problem.titleItalic}</span>
          </h2>
          <p className="mt-8 max-w-2xl text-po-text2 text-base sm:text-lg leading-relaxed">
            {t.problem.sub}
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-8 gap-5">
          {t.problem.cards.map((c, i) => {
            const Icon = icons[i] || TrendingDown;
            const layouts = ["md:col-span-5", "md:col-span-3", "md:col-span-3", "md:col-span-5"];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.07 }}
                data-testid={`problem-card-${i}`}
                className={`group relative ${layouts[i]} rounded-3xl bg-po-surface/60 border border-white/[0.05] p-8 md:p-10 backdrop-blur-sm overflow-hidden hover:border-po-accent/30 hover:-translate-y-1 transition-all duration-500`}
              >
                <div className="absolute -top-20 -right-20 h-48 w-48 rounded-full bg-po-accent/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                <div className="relative flex items-start gap-5">
                  <div className="shrink-0 h-11 w-11 rounded-xl bg-po-accent/10 border border-po-accent/20 flex items-center justify-center text-po-accent">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-white text-xl md:text-2xl tracking-tight font-medium">{c.t}</h3>
                    <p className="mt-3 text-po-text2 text-[15px] leading-relaxed">{c.d}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Problem;
